import * as React from 'react';

export function Professionalize() {
  return (
    <section className="bp-pro">
      <style>{`
        .bp-pro {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .bp-pro-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .bp-pro h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          text-align: center;
        }
        .bp-pro .subtitle {
          font-size: 16px;
          color: #666;
          text-align: center;
          margin: 0 0 40px;
        }
        .bp-pro-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }
        .bp-pro-card {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          background: #fff;
          border-radius: 12px;
          padding: 18px 20px;
          border: 1px solid #eee;
        }
        .bp-pro-card .card-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #f0fdf0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .bp-pro-card .card-icon i {
          font-size: 18px;
          color: #1EAA25;
        }
        .bp-pro-card-text h3 {
          font-size: 15px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 4px;
        }
        .bp-pro-card-text p {
          font-size: 14px;
          color: #666;
          line-height: 1.5;
          margin: 0;
        }
        .bp-pro .closing {
          text-align: center;
          font-size: 16px;
          color: #333;
          font-weight: 600;
          margin: 36px 0 0;
        }
        @media (max-width: 768px) {
          .bp-pro-cards {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .bp-pro h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="bp-pro-inner">
        <h2>Cómodo, rápido y sin vueltas</h2>
        <p className="subtitle">Comprar frutas y verduras frescas tiene que ser fácil.</p>

        <div className="bp-pro-cards">
          <div className="bp-pro-card">
            <div className="card-icon"><i className="fa fa-mobile-alt" /></div>
            <div className="bp-pro-card-text">
              <h3>Pedí cuando quieras</h3>
              <p>Tienda online 24 hs. Pedí desde el celular sin llamar a nadie.</p>
            </div>
          </div>
          <div className="bp-pro-card">
            <div className="card-icon"><i className="fa fa-map-marker-alt" /></div>
            <div className="bp-pro-card-text">
              <h3>Entrega en tu barrio</h3>
              <p>Coordinamos con la guardia y llegamos hasta tu puerta.</p>
            </div>
          </div>
          <div className="bp-pro-card">
            <div className="card-icon"><i className="fa fa-redo" /></div>
            <div className="bp-pro-card-text">
              <h3>Repetí tu pedido</h3>
              <p>Historial de compras y recompra con un click. Sin armar todo de nuevo.</p>
            </div>
          </div>
        </div>

        <p className="closing">Comer bien no tiene que ser complicado.</p>
      </div>
    </section>
  );
}
